import canucciLogoWhite from "@/assets/logos/canucci-logo-white.svg?url";
import { useAuth } from "@canucci/base/auth";
import { LoginPage as SharedLoginPage } from "@canucci/base-mantine/auth";
import { Anchor, Box } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const isSignUpPath = location.pathname === "/signup";
  const { t } = useTranslation("pages");
  const { deepLink } = useAuth();

  return (
    <SharedLoginPage
      onLoginSuccess={() => navigate(deepLink ?? "/")}
      initialSignUp={isSignUpPath}
      onSignUpModeChange={(isSignUp) => {
        navigate(isSignUp ? "/signup" : "/login", { replace: true });
      }}
      logo={
        <Box component="img" src={canucciLogoWhite} alt="Canucci" h={28} style={{ display: "block", width: "auto" }} />
      }
      subtitle={t("login.subtitle")}
      translate={(key, vars) => (vars ? t(key, vars) : t(key))}
      footerAgreement={
        <>
          {t("login.footer.agreementPrefix", "By signing in, you agree to our ")}
          <Anchor component={Link} to="/terms-of-service" fz="xs" inherit>
            {t("general.root.footer.terms_of_service")}
          </Anchor>
          <span style={{ whiteSpace: "nowrap" }}>
            {" and "}
            <Anchor component={Link} to="/privacy-policy" fz="xs" inherit>
              {t("general.root.footer.privacy_policy")}
            </Anchor>
            {"."}
          </span>
        </>
      }
      footerSupportLink={{
        label: t("general.root.support.button"),
        href: "https://www.canucci.com",
      }}
    />
  );
}
